import { DetalleDte } from "src/app/models/Dte/DetalleDte";
import { IDte } from "src/app/models/Dte/IDte";
import { InvoiceType } from "src/app/models/Dte/invoiceType.enum";

export interface DteCalculationContext {
	dte: IDte;
	invoiceType: InvoiceType;
	tipoNota: number;
	detallesConImpuestosIncluidos: boolean;
	porcentajeIva: number;
}

export function calcularTotalDetalles(contexto: DteCalculationContext): number {
	const { dte, invoiceType, tipoNota, detallesConImpuestosIncluidos, porcentajeIva } = contexto;
	if (invoiceType === InvoiceType.NotaCredito && tipoNota === 2) return 0;
	if (invoiceType === InvoiceType.LiquidacionFactura) return 1;

	const detalles = dte.detalleDte || [];
	const descuentoGlobal = Number(dte.descuentoGlobal || 0);
	let neto = 0;
	let bruto = 0;
	let exento = 0;

	if (invoiceType === InvoiceType.FacturaExportacion) {
		exento = Number(dte.exento || 0) - descuentoGlobal;
	} else if (detallesConImpuestosIncluidos) {
		if (Number(dte.impuestos || 0) > 0) {
			detalles.forEach((detalle) => {
				if (detalle.esExento) {
					exento += Number(detalle.total || 0);
					return;
				}
				const tasaAdicional = (detalle.impuestosAdicionales || []).reduce((total, impuesto) => total + Number(impuesto.tasa || 0), 0);
				neto += Math.round(Number(detalle.total || 0) / (1 + tasaAdicional / 100 + porcentajeIva));
			});
		} else {
			detalles.forEach((detalle) => {
				if (detalle.esExento) exento += Number(detalle.total || 0);
				else bruto += Number(detalle.total || 0);
			});
			neto = invoiceType === InvoiceType.Boleta && bruto > 0
				? (bruto - descuentoGlobal) / (1 + porcentajeIva)
				: bruto / (1 + porcentajeIva);
		}
	} else {
		detalles.forEach((detalle) => {
			if (detalle.esExento) exento += Number(detalle.total || 0);
			else neto += Number(detalle.total || 0);
		});
	}

	if (invoiceType === InvoiceType.Boleta && dte.codigoTipoDte !== 41) {
		const descuentoNeto = Number(dte.impuestos || 0) > 0 ? Math.round(descuentoGlobal / (1 + porcentajeIva)) : descuentoGlobal;
		return Math.round(neto) + exento - descuentoNeto;
	}
	if (invoiceType === InvoiceType.FacturaExportacion) return exento;
	return Math.round(neto) + exento - descuentoGlobal;
}

export function tieneDetallesConMontosInvalidos(dte: IDte, invoiceType: InvoiceType, tipoNota: number): boolean {
	if (invoiceType === InvoiceType.NotaCredito && tipoNota === 2) return false;
	if (dte.guiaDespacho?.tipoTraslado === 5) return false;
	return (dte.detalleDte || []).some((detalle) =>
		Number(detalle.total || 0) === 0 || Number(detalle.cantidad || 0) === 0 || Number(detalle.precioUnitario || 0) === 0
	);
}

export function crearDetalleSinImpuestos(detalleOriginal: DetalleDte, porcentajeIva: number): DetalleDte {
	const detalle = Object.assign(new DetalleDte(), JSON.parse(JSON.stringify(detalleOriginal)));
	detalle.precioUnitario = Number(detalle.precioUnitario || 0) / (1 + porcentajeIva);
	detalle.recargo = Number(detalle.recargo || 0) / (1 + porcentajeIva);
	detalle.descuento = Number(detalle.descuento || 0) / (1 + porcentajeIva);
	detalle.subtotal = detalle.precioUnitario * Number(detalle.cantidad || 0) - detalle.descuento + detalle.recargo;
	detalle.total = detalle.subtotal;
	return detalle;
}
